/* ============
 * Actions for the formalities module
 * ============
 *
 * The actions that are available on the
 * formalities module.
 */
import axios from 'axios'

const ESTADOS_FLUJO_TI = ['PENDIENTE SAC', 'PROCESADO RPA']

const esFlujoTi = (state) => ESTADOS_FLUJO_TI.includes((state || '').trim())

export default {
  getMaxAmountEndorse ({ dispatch }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'policies/endorsements/max-amounts/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  getPolicyDataPerEndoso ({ dispatch }, item) {
    let api = process.env.API_URL
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'policies/info/endorsements/' + item.numeroPoliza)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  checkIfPolicyHasPendingOkEndoso ({ dispatch }, item) {
    let api = process.env.API_FORMALITIES
    return new Promise((resolve, reject) => {
      dispatch('checkJWT').then(() => {
        axios.get(api + 'requirement/all?policy=' + item.numeroPoliza + '&type=Endoso%20a%20entidad%20financiera&state=PENDIENTE')
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    })
  },
  makeEndorsement ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'lines/life/requirements/endorsements', item, { timeout: 300000 })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Endosos simples: Cambio de frecuencia y Eliminación de cobertura
  makeEndorsementRequirement ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      // Endpoint específico para el nuevo flujo controlado
      axios.post(apiV2 + 'lines/life/endorsements/requirements', item, { timeout: 300000 })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Simulación de endoso
  simularEndoso ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'lines/life/requirements/endorsements/simulations', item, { timeout: 300000 })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Obtener fecha efectiva para endoso
  obtenerFechaEfectiva ({ dispatch }, params) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.post(apiV2 + 'lines/life/endorsements/effective-dates', {
        tipoEndoso: params.tipoEndoso,
        numeroPoliza: params.numeroPoliza,
        fechaSolicitud: params.fechaSolicitud
      }, { timeout: 30000 })
        .then(res => {
          if (res.data.codigoRespuesta === '01') {
            resolve(res.data)
          } else {
            reject(new Error(res.data.mensajeRespuesta))
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getDocsEndorsement ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.get(apiV2 + 'lines/life/requirements/' + item + '/documents')
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  downloadPdfEndorsement ({ dispatch }, item) {
    let apiV2 = process.env.API_URL_V2
    return new Promise((resolve, reject) => {
      axios.get(
        apiV2 + 'lines/life/requirements/' + item.reqId + '' + '/documents/' + item.docId,
        { params: { state: item.state, filename: item.filename } }
      )
        .then(res => {
          if (res.data.code !== '01') {
            resolve(res)
            return
          }

          const { url, filename } = res.data.data

          if (esFlujoTi(item.state)) {
            fetch(url)
              .then(response => response.blob())
              .then(blob => {
                const blobUrl = window.URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = blobUrl
                a.download = filename
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                window.URL.revokeObjectURL(blobUrl)
                resolve(res)
              })
              .catch(reject)
            return
          }

          const a = document.createElement('a')
          a.href = url
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // Delegado en la sesión de CR Auth (user/ensureSession); nunca rechaza, igual que antes
  checkJWT ({ dispatch }) {
    return dispatch('user/checkJWT', null, { root: true })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/endorsements/actions.js